import { useQueryClient } from 'react-query';
import { ProjectId, UserType } from 'api/models';
import { useInviteUserToProjectConfirmation } from 'hooks/use-invite-user-to-project';
import { getProjectMembersQueryKey } from 'queries';
import { ALL_USERS_QUERY_KEY } from 'queries/members';
import { invitableUser } from './utils';

export const useCustomInviteUserToProjectConfirmation = (
  projectId?: ProjectId,
) => {
  const confirm = useInviteUserToProjectConfirmation();
  const queryClient = useQueryClient();

  return <
    UserOption extends { extra: { id: number }; userType: UserType },
    Selected extends unknown,
  >(
    nonProjectUserOptions: UserOption[] = [],
    selectedOptions: Selected[] = [],
    originalValue: Selected[] = [],
    commitFnc: (value: Selected[]) => void,
    onCancel: (value: Selected[]) => void,
    paramProjectId?: ProjectId,
  ) =>
    confirm(
      (projectId || paramProjectId)!,
      nonProjectUserOptions.map(invitableUser),
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries(
            getProjectMembersQueryKey((projectId || paramProjectId)!),
          );
          await queryClient.invalidateQueries(ALL_USERS_QUERY_KEY);
          commitFnc(selectedOptions);
        },
        onError: () => {
          commitFnc(originalValue);
        },
      },
      {
        onCancel: () => {
          onCancel(selectedOptions);
        },
      },
    );
};
